module.exports = __webpack_public_path__ + "media/stylesheets/images/icon/bell-e85503e63fbea8393af478459dcfb076.svg";